import React from 'react'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next'
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';


export const MerchoidSalesDashboardView = (props) => {
  

  const defaultSorted = [{
    dataField: "margin",
    order: "asc"  // or desc
  }];

  const expandRow = {
    onlyOneExpanding: true,
    renderer: row => (
      <div>
        <div><h4>Workings</h4></div>
        <table>
          <tr>
            <th>
              Product cost price
            </th>
            <th>
              Packaging cost
            </th>
            <th>
              Shipping cost
            </th>
            <th>
              Bubblewrap cost
            </th>
            <th>
              Sale transaction cost
            </th>
            <th>
              Total Cost
            </th>
          </tr>
          <tr>
            <td>
              {`£${row.costPrice.toFixed(2)}`}
            </td>
            <td>
              {`£${row.packagingCost.toFixed(2)}`}
            </td>
            <td>
              {`£${row.shippingCost.toFixed(2)}`}
            </td>
            <td>
              {`£${row.bubbleWrapCost.toFixed(2)}`}
            </td>
            <td>
              {`£${row.transactionFee.toFixed(2)}`}
            </td>
            <td>
              <strong>{'£' + (parseFloat(row.costPrice) + parseFloat(row.packagingCost) + parseFloat(row.shippingCost) + parseFloat(row.bubbleWrapCost) + parseFloat(row.transactionFee))}</strong>
            </td>
          </tr>
        </table>

        <table className='mt-3'>

          <tr>
            <th>Native Selling Currency</th>
            <th>Original selling price (pre-discounts, ex VAT, native)</th>
            <th>Native selling price (ex-VAT)</th>
            <th>GBP selling price ex-VAT</th>
            <th>Total Cost Price</th>
            <th>Profit</th>
            <th>Margin</th>
          </tr>
          <tr>
            <td>
              {row.currency}
            </td>
            <td>
              {row.originalPrice}
            </td>
            <td>
              {getCurrencySymbol(row.shippingCountry) + row.sellingPrice.toFixed(2)}
            </td>
            <td>
              {'£' + row.sellingPriceGbp.toFixed(2)}
            </td>
            <td>
              {'£' + (parseFloat(row.costPrice) + parseFloat(row.packagingCost) + parseFloat(row.shippingCost) + parseFloat(row.bubbleWrapCost) + parseFloat(row.transactionFee)).toFixed(2)}
            </td>
            <td>
              {'£' + row.profit.toFixed(2)}
            </td>
            <td>
              {(row.margin * 100).toFixed(2) + '%'}
            </td>
          </tr>
        </table>
      </div>

    )
  };


  const columns = [{
    dataField: 'orderId',
    text: 'Order Id',
    sort: true
  }, {
    dataField: 'date',
    text: 'Date',
    formatter: cell => new Date(cell).toLocaleString(),
    sort: true
  }, {
    dataField: 'sku',
    text: 'SKU',
    formatter: cell => <a href={'https://h.merchoid.com/admin5YodaRed5Palpatine2/?page=inventoryEdit&productId=' + cell} target="_blank" rel="noreferrer">{cell}</a>
  },
  {
    dataField: 'productTitle',
    text: 'Title',
    filter: textFilter(),
    sort: true
  },
  {
    dataField: 'qty',
    text: 'QTY'
  },
  {
    dataField: 'packaging',
    text: 'Packaging',
  },
  {
    dataField: 'totalWeight',
    text: 'Total Weight',
    sort: true,
    formatter: (cell) => cell + 'g'
  },
  {
    dataField: 'sellingPrice',
    text: 'Selling Price',
    formatter: (cell, row) => {
      const currencySymbol = getCurrencySymbol(row.shippingCountry);
      return currencySymbol + cell.toFixed(2);
    },
    sort: true
  },


  {
    dataField: 'shippingCost',
    text: 'Shipping Cost',
    formatter: cell => '£' + (cell).toFixed(2),
    sort: true
  },
  {
    dataField: 'shippingCountry',
    text: 'Shipping Country',
    filter: textFilter(),
    sort: true
  },
  {
    dataField: 'profit',
    text: 'Profit',
    sort: true,
    formatter: (cell) => '£' + (cell).toFixed(2)
  },
  {
    dataField: 'largeLetter',
    text: 'Large Letter?',
    sort: true,
    formatter: (cell) => cell === true ? 'Yes' : 'No'
  },
  {
    dataField: 'margin',
    text: 'Margin',
    sort: true,
    sortFunc: (a, b, order) => {
      // Assuming 'a' and 'b' are the margin values of the rows being compared
      let valueA = a !== null ? a : 0.005; // Use 0.005 instead of false or null
      let valueB = b !== null ? b : 0.005;

      if (order === 'asc') {
        return valueA - valueB;
      }
      return valueB - valueA;
    },
    formatter: (cell, row) => {
      if (!row.margin) {
        return ''
      } else return (row.margin * 100).toFixed(2) + '%'
    }

  },
  {
    dataField: 'notes',
    text: 'Notes',
    formatter: (cell, row) => {
      return cell
    },
    filter: textFilter()

  }

  ];

  return <div>
    <div>
      <div>Start Date</div>
      <DatePicker disabled={!props.loaded} selected={props.startDate} onChange={(date) => props.setStartDate(date)} />
      <div>End Date</div>
      {props.loaded &&
        <div>Average margin for the period: {(props.avgMargin * 100).toFixed(2)}%</div>

      }
      <DatePicker disabled={!props.loaded} selected={props.endDate} onChange={(date) => props.setEndDate(date)} />
      {!props.loaded && <h3>Loading...</h3>}
      {props.loaded && <BootstrapTable keyField='orderId' data={props.data} columns={columns} expandRow={expandRow} bootstrap4={true} defaultSorted={defaultSorted} filter={filterFactory()} pagination={paginationFactory({ sizePerPage: 100 })} />}

    </div>
  </div>
}

function getCurrencySymbol(shippingCountry) {
  switch (shippingCountry) {
    case 'GB':
      return '£';
    case 'US':
      return '$';
    case 'CA':
      return 'CAD $';
    case 'AU':
      return 'AUD $';
    default:
      return ''; // default or perhaps another currency symbol if needed
  }
}
